import {featureInSection} from './featureInSection';
import {getProductData} from './getProductData';
import {regionCheck} from './regionCheck';
import {isSatisfied} from './values';
import {selectProductData, selectRegion, selectSectionConfig, selectSpcAttributes} from '../selectors';

export function visibleFeatures(sectionId, state) {

	const sectionConfig = selectSectionConfig(state);
	const spcAttributes = selectSpcAttributes(state);
	const productData = selectProductData(state);
	const region = selectRegion(state);

	if (sectionId) {
		const section = sectionConfig.find(s => s.id === sectionId);
		if (spcAttributes && spcAttributes.length > 0) {
			return spcAttributes
				.filter(feature => featureInSection(sectionConfig, section, feature.key))
				.filter(feature => getProductData(feature.key, productData)?.isVisible)
				.filter(feature => regionCheck(getProductData(feature.key, productData), region));
		} else {
			return [];
		}
	} else {
		return [];
	}
}

export function isSectionSatisfied(sectionId, state) {
	const sectionConfig = selectSectionConfig(state);
	const spcAttributes = selectSpcAttributes(state);

	if (sectionId) {
		const section = sectionConfig.find(s => s.id === sectionId);
		let customSectionSatisfied;
		let featuresOfSectionSatisfied;
		if(section.hasOwnProperty('isSatisfied')) {
			// result of custom function to check if the section is satisfied ...
			customSectionSatisfied = section.isSatisfied(state);
		} else {
			customSectionSatisfied = true;
		}
		if(section.hasOwnProperty('features') && section.features.length > 0) {
			// check if all features of the section are satisfied
			featuresOfSectionSatisfied = visibleFeatures(sectionId, state)
				.reduce((acc, feature) => acc && isSatisfied(feature.key, spcAttributes), true);
		} else {
			featuresOfSectionSatisfied = true;
		}
		// return true if both conditions are satisfied
		return customSectionSatisfied && featuresOfSectionSatisfied;
	} else {
		return false;
	}
}

export function completionPercentage(sectionId, state) {
	const sectionConfig = selectSectionConfig(state);
	const spcAttributes = selectSpcAttributes(state);

	const section = sectionConfig.find(s => s.id === sectionId);
	const features = visibleFeatures(sectionId, state);
	let visibleCount = features.length ?? 100;
	let satisfiedCount = features.filter(feature => isSatisfied(feature.key, spcAttributes)).length ?? 0;

	if(section.hasOwnProperty('isSatisfied')) {
		visibleCount += 1;
		satisfiedCount += section.isSatisfied(state) ? 1 : 0;
	}

	return Math.round((satisfiedCount / visibleCount * 100));
}
